/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { DeviceDto } from './device-dto';
import { PaginationMetaDto } from './pagination-meta-dto';
 /**
 *
 *
 * @export
 * @interface DevicePaginatedResponseDto
 */
export interface DevicePaginatedResponseDto {

    /**
     * @type {Array<DeviceDto>}
     * @memberof DevicePaginatedResponseDto
     */
    data: Array<DeviceDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof DevicePaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
